// eslint-disable-next-line
/* global FormData */
// import classNames from 'classnames'
import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import useToastContext from "hooks/useToastContext";
import { useForm } from "react-hook-form";
import ErrorMessage from "components/ErrorMessage";
import { isEmpty, orderBy, get as __get } from "lodash";
import OInputField from "components/reusable/OInputField";
import { useTranslation } from "react-i18next";
import { apiGet, apiPost, apiPut } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import OSelect from "components/reusable/OSelect";
import OImage from "components/reusable/OImage";
import { useLocation, useNavigate } from "react-router-dom";
import { PROPERTY_ALLOWED_PHOTO_EXT } from "../../utils/constants";
import photoClose from "../../assets/images/photo_close.png";
import AuthContext from "context/AuthContext";
import helper from "utils/helpers";
import OMultiSelect from "components/reusable/OMultiSelect";
import { Autocomplete, TextField } from "@mui/material";

const imageCountMax = 10;
const AddUnit = () => {
  const { t } = useTranslation();
  const { config } = useContext(AuthContext);
  const notification = useToastContext();
  const location = useLocation();
  const navigate = useNavigate();
  const [editProperty, setEditProperty] = useState(location?.state?.item ?? "");

  const {
    register,
    setValue,
    // watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const planRef = useRef();
  const ratinaPlanRef = useRef();
  const imageRef = useRef();
  const vrRef = useRef();
  const ratinaImageRef = useRef();
  const interiorRef = useRef();
  const ratinainteriorRef = useRef();

  const [propertyCategoryTypes, setPropertyCategoryTypes] = useState([]);
  const [unitTypeNumbers, setUnitTypeNumbers] = useState([]);

  const [propertyAmenitiesList, setPropertyAmenitiesList] = useState([]);

  const [deletedImage, setDeletedImage] = useState([]);
  const [deletedFloorPlan, setDeletedFloorPlan] = useState([]);
  const [isDeletePhoto, setIsDeletePhoto] = useState(false);

  const [floorData, setFloorData] = useState([
    {
      titleFloorPlan: "",
      titleFloorPlanAr: "",
      image: "",
    },
  ]);

  // const [paymentPercent, setPaymentPercent] = useState([
  //   {
  //     paymentTitle: '',
  //     paymentTitleAr: '',
  //     percentage: ''
  //   }
  // ])

  const [selectedPhotos, setSelectedPhotos] = useState([]);

  const [paymentPercent, setPaymentPercent] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [florOption, setFlorOption] = useState([]);
  const [bedroomOption, setBedroomOption] = useState([]);
  const [bathroomOption, setBathroomOption] = useState([]);
  const [isMain, setIsMain] = useState(true);
  const [isSpecialOffer, setIsSpecialOffer] = useState(true);
  const [tempImage, setTempImage] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [plan, setPlan] = useState([]);
  const [ratinaPlan, setRatinaPlan] = useState([]);
  const [image, setImage] = useState([]);
  const [vrImage, setVrImage] = useState([]);
  const [ratinaImage, setRatinaImage] = useState([]);
  const [interior, setInterior] = useState([]);
  const [ratinaInterior, setRatinaInterior] = useState([]);
  const [isMortgageAvailable, setIsMortgageAvailable] = useState(false);
  const [showInWebsite, setShowInWebsite] = useState(true);
  const [showInAgentApp, setShowInAgentApp] = useState(true);
  const [showInCustomerApp, setShowInCustomerApp] = useState(true);
  const [freelancerAgents, setFreelancerAgents] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);

  const [paymentOptions, setPaymentOption] = useState([
    {
      label: "Full Payment",
      value: "full_payment",
    },
  ]);
  const paymentOptionsArray = [
    {
      label: "Installment",
      value: "installment",
    },
    {
      label: "Full Payment",
      value: "full_payment",
    },
    {
      label: "Mortgage",
      value: "mortgage",
    },
  ];

  var florlength = 50;
  var bedroomlength = 11;
  var bathroomlength = 11;

  useEffect(() => {
    getProjects();
    fetchMasterRecords();
    getFlorOption();
    getBedrooms();
    getbathrooms();
  }, []);

  useEffect(() => {
    const fetchFreelancerAgents = async () => {
      try {
        const response = await apiGet(apiPath.freelancerAgents);
        const data = response?.data?.results || [];
        setFreelancerAgents(Array.isArray(data) ? data : []);
      } catch (error) {
        console.log(error);
      }
    };
    fetchFreelancerAgents();
  }, []);

  const getFlorOption = () => {
    let data = [];
    data.push({ key: `Ground Floor`, value: `Ground Floor` });
    for (var i = 1; i < florlength; i++) {
      data.push({ key: `${i} Floor`, value: `${i} Floor` });
    }
    setFlorOption(data);
  };

  const getBedrooms = () => {
    let data = [];
    data.push({ key: `Select`, value: `` });
    for (var i = 1; i < bedroomlength; i++) {
      data.push({ key: `${i}-Bedroom`, value: `${i}-Bedroom` });
    }
    setBedroomOption(data);
  };

  const getbathrooms = () => {
    let data = [];
    data.push({ key: `Select`, value: `` });
    for (var i = 1; i < bathroomlength; i++) {
      data.push({ key: `${i}-Bathroom`, value: `${i}-Bathroom` });
    }
    setBathroomOption(data);
  };

  const blockOption = [
    { key: "Select", value: "" },
    { key: "Block-A", value: "Block-A" },
    { key: "Block-B", value: "Block-B" },
    { key: "Block-C", value: "Block-C" },
    { key: "Block-D", value: "Block-D" },
  ];

  const statusOption = [
    { key: "Available", value: "Available" },
    { key: "Not Available", value: "Not Available" },
    { key: "Booked", value: "Booked" },
    { key: "Sold Out", value: "Sold Out" },
    { key: "Resale", value: "Resale" },
  ];
  const unitTypeOption = [
    { key: "Apartment", value: "Apartment" },
    { key: "Townhouse", value: "Townhouse" },
    { key: "Villa", value: "Villa" },
    { key: "Land", value: "Land" },
    { key: "Duplex", value: "Duplex" },
    { key: "Penthouse", value: "Penthouse" },
    { key: "Office", value: "Office" },
    { key: "Full Floor", value: "Full Floor" },
    { key: "Bulk Unit", value: "Bulk Unit" },
    { key: "Co-working space", value: "Co-working space" },
  ];

  const [taxPrice, setTaxPrice] = useState({
    cost: "",
    propertyTax: "",
    propertyTaxPercentage: "",
    commission: "",
    commissionPercentage: "",
    commissionTax: "",
    commissionTaxPercentage: "",
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      const {
        cost,
        propertyTaxPercentage,
        commissionPercentage,
        commissionTaxPercentage,
      } = taxPrice;

      const propertyTax = getPercentage(cost, propertyTaxPercentage);
      const commission = getPercentage(cost, commissionPercentage);
      const commissionTax = getPercentage(commission, commissionTaxPercentage);

      setTaxPrice((prev) => ({
        ...prev,
        propertyTax,
        commission,
        commissionTax,
      }));
    }, 500);

    return () => clearTimeout(timeout);
  }, [taxPrice]);

  const getPercentage = (price, value) => {
    return (price * (parseFloat(value) || 0)) / 100;
  };

  const handleInputChange = (field, value) => {
    const numberValue = parseFloat(value);
    if (!isNaN(numberValue)) {
      setTaxPrice((prev) => ({
        ...prev,
        [field]: Math.min(Math.max(numberValue, 0), 100), // Clamp value between 0 and 100
      }));
    } else {
      setTaxPrice((prev) => ({
        ...prev,
        [field]: null, // Set to 0 if input is invalid
      }));
    }
  };

  const handleSubmitForm = async (data) => {
    const request = {
      ...data,
      ...taxPrice,
      propertyTaxPercentage: taxPrice?.propertyTaxPercentage ?? 0,
      commissionPercentage: taxPrice?.commissionPercentage ?? 0,
      commissionTaxPercentage: taxPrice?.commissionTaxPercentage ?? 0,
      paymentOptions: paymentOptions.map((res) => res.value),
      projectId: selectedProject,
      component: paymentPercent.map((res) => res.component),
      componentAr: paymentPercent.map((res) => res.componentAr),
      plan: replaceUrl(plan),
      ratinaPlan: replaceUrl(ratinaPlan),
      image: replaceUrl(image),
      vrImage: replaceUrl(vrImage),
      ratinaImage: replaceUrl(ratinaImage),
      interior: replaceUrl(interior),
      ratinaInterior: replaceUrl(ratinaInterior),
      isMain: isMain ? "Yes" : "No",
      isSpecialOffer: isSpecialOffer ? "Yes" : "No",
      isMortgageAvailable: isMortgageAvailable || false,
      showInWebsite: showInWebsite || false,
      showInAgentApp: showInAgentApp || false,
      showInCustomerApp: showInCustomerApp || false,
      agentIds: selectedAgents.map((agent) => agent._id),
    };

    // let isValid = true;
    // if (!isValid) return;
    try {
      const { data: response } = await apiPost(apiPath.unitPath, request);

      if (response?.success) {
        notification.success(response?.message);
        navigate("/units");
      } else {
        notification.error(response?.message);
      }
    } catch (error) {
      notification.error(error?.message);
    }
  };

  const fetchMasterRecords = async (data) => {
    try {
      const payload = { ...data };
      const path = apiPath.PropertiesMasterData;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      const propertyTypes = records?.propertyTypes?.find(
        (res) => res.type === "Project",
      );
      const filteredCategories = records?.propertyCategories
        ?.filter((pt) => pt.propertyTypeId === propertyTypes?._id)
        .map((c) => ({ key: c.name, value: c._id }));
      setPropertyCategoryTypes(filteredCategories || []);
      setUnitTypeNumbers(records?.unitTypeNumbers || []);
      setPropertyAmenitiesList(records?.propertyAmenities || []);
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };

  const [projects, setProjects] = useState([]);
  const getProjects = async (projectId = "") => {
    try {
      const payload = {};
      const path = apiPath.projectPath + "/all-projects";
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      setProjects(records);
      startTransition(() => {
        setValue("projectId", projectId);
      });
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };

  const setDeleteIcon = () => {
    if (photos.length > 6) {
      setIsDeletePhoto(true);
    } else {
      setIsDeletePhoto(false);
    }
  };

  const replaceUrl = (data) => {
    //const baseUrl = "https://mada-properties-staging.s3.me-south-1.amazonaws.com/"
    for (var i = 0; i < data.length; i++) {
      const dbUrl = data[i]?.split(config?.country === "Saudi" ? "o/" : "net/");
      data[i] = dbUrl[1];
      //data[i] = data[i].replace(baseUrl,'');;
    }
    return data;
  };

  const removePhotos = async (index, type) => {
    if (typeof index !== "object") {
      let check =
        tempImage?.length > 0
          ? tempImage?.find((res) => res?.image == index)
          : {} || {};
      if (!isEmpty(check)) {
        apiPut(apiPath.deleteTempPhoto + check?._id, { type: "project" });
        setTempImage((prev) => {
          return prev?.filter((res) => res.image !== index);
        });
        // setPhotos(prev => {
        //   return prev?.filter(res => res !== index)
        // })
        switch (type) {
          case "plan":
            setPlan((prev) => {
              return prev?.filter((res) => res !== index);
            });
            break;
          case "ratinaPlan":
            setRatinaPlan((prev) => {
              return prev?.filter((res) => res !== index);
            });
            break;
          case "image":
            setImage((prev) => {
              return prev?.filter((res) => res !== index);
            });
            break;
          case "vrImage":
            setVrImage((prev) => {
              return prev?.filter((res) => res !== index);
            });
            break;
          case "ratinaImage":
            setRatinaImage((prev) => {
              return prev?.filter((res) => res !== index);
            });
            break;
          case "interior":
            setInterior((prev) => {
              return prev?.filter((res) => res !== index);
            });
            break;
          case "ratinaInterior":
            setRatinaInterior((prev) => {
              return prev?.filter((res) => res !== index);
            });
            break;

          default:
            break;
        }
      } else {
        const dbUrl = index?.split(config?.country === "Saudi" ? "o/" : "net/");
        setDeletedImage((prev) => [...prev, dbUrl[1]]);
      }
    }
    setPhotos((prev) => {
      return prev.filter((res) => res !== index);
    });
  };

  const uploadTemporaryPhotos = async (e, type) => {
    const formData = new FormData();
    if (!isEmpty(editProperty?._id)) {
      formData.append("projectId", editProperty?._id);
    }
    formData.append("isSignature", selectedProject?.isSignature || false);
    formData.append("image", e);
    const { data: response } = await apiPost(
      apiPath.uploadTemporaryPhotos,
      formData,
    );
    if (response.success) {
      switch (type) {
        case "plan":
          setPlan((prev) => {
            return [...prev, response?.results?.image];
          });
          break;
        case "ratinaPlan":
          setRatinaPlan((prev) => {
            return [...prev, response?.results?.image];
          });
          break;
        case "image":
          setImage((prev) => {
            return [...prev, response?.results?.image];
          });
          break;
        case "vrImage":
          setVrImage((prev) => {
            return [...prev, response?.results?.image];
          });
          break;
        case "ratinaImage":
          setRatinaImage((prev) => {
            return [...prev, response?.results?.image];
          });
          break;
        case "interior":
          setInterior((prev) => {
            return [...prev, response?.results?.image];
          });
          break;
        case "ratinaInterior":
          setRatinaInterior((prev) => {
            return [...prev, response?.results?.image];
          });
          break;

        default:
          break;
      }
      setTempImage((prev) => {
        return [...prev, response?.results];
      });
      // setPhotos(prev => {
      //   return [...prev, response?.results?.image]
      // })
    } else {
      notification.error(response?.message);
    }
  };

  const handlePhotosChange = (e, name) => {
    const files = e.target.files;
    const tempFile = Object.values(files);
    // if ([...selectedPhotos, ...tempFile, ...photos]?.length < imageCount) {
    //   notification.error('Please upload min 6 images.')
    //   return false
    // }
    if ([...selectedPhotos, ...tempFile].length > imageCountMax) {
      if (selectedPhotos.length === 0 && [...tempFile].length > imageCountMax) {
        notification.error("Only 10 photos are allowed to upload at a time.");
      } else if (
        selectedPhotos.length === imageCountMax &&
        [...selectedPhotos, ...tempFile].length > imageCountMax
      ) {
        notification.error("Only 10 photos are allowed to upload at a time.");
      } else if ([...selectedPhotos, ...tempFile, ...photos].length > 20) {
        notification.error("Max 20 photos are allowed to upload.");
      } else {
        notification.error(
          `Now you select only ${
            imageCountMax - selectedPhotos.length
          } photos.`,
        );
      }
    } else {
      for (let i = 0; i < files?.length; i++) {
        const fileSize = helper.getFileSize(files[i]);
        const getType = files[i].type.split("/");
        if (PROPERTY_ALLOWED_PHOTO_EXT.includes(getType[1])) {
          if (fileSize > 2) {
            notification.error(
              "Please select photos below 2 MB (photos has been discarded which is above 2 MB)",
            );
          } else {
            uploadTemporaryPhotos(files[i], name);
            // setSelectedPhotos(prev => {
            //   if (prev?.length > 0) {
            //     return [...prev, files[i]]
            //   } else {
            //     return [files[i]]
            //   }
            // })
          }
        } else {
          notification.error(
            `Only ${PROPERTY_ALLOWED_PHOTO_EXT.join(
              ", ",
            )} photos are allowed to upload.`,
          );
        }
      }
    }
  };

  const addMorePaymentPercentage = () => {
    setPaymentPercent([
      ...paymentPercent,
      {
        component: "",
        componentAr: "",
      },
    ]);
  };

  useEffect(() => {
    setDeleteIcon();
    // eslint-disable-next-line
  }, [photos]);

  const deleteMore = (type, index, img) => {
    switch (type) {
      case "percentage":
        setPaymentPercent(
          paymentPercent.filter((percentage, tempIndex) => tempIndex !== index),
        );
        break;
      case "floorPlan":
        if (typeof img !== "object") {
          const dbUrl = img?.split(config?.country === "Saudi" ? "o/" : "net/");
          setDeletedFloorPlan((prev) => [...prev, dbUrl[1]]);
        }
        setFloorData(
          floorData.filter((percentage, tempIndex) => tempIndex !== index),
        );
        break;
      default:
        break;
    }
  };

  const dragItem = useRef();
  const dragOverItem = useRef();

  const dragStart = (e, position) => {
    dragItem.current = position;
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    const copyListItems = [...photos];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setPhotos(copyListItems);
  };
  return (
    <>
      <div className="basic_info px-4 ">
        <form
          className="py-4"
          onSubmit={handleSubmit(handleSubmitForm, () => {
            // checkValidation()
          })}
        >
          <div className="">
            <div className="grid grid-rows-1 grid-cols-1 gap-4 mb-3">
              <Autocomplete
                multiple
                disableCloseOnSelect
                id="unit-add-freelancer-agents"
                options={freelancerAgents}
                getOptionLabel={(option) =>
                  `${option?.firstName ?? ""} ${option?.lastName ?? ""}`.trim() ||
                  option?.brn ||
                  ""
                }
                isOptionEqualToValue={(option, value) =>
                  String(option._id) === String(value._id)
                }
                value={selectedAgents}
                onChange={(event, newValue) => {
                  setSelectedAgents(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Agents (Freelancer)"
                    placeholder="Select agents"
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "rgb(249 250 251)",
                      },
                    }}
                  />
                )}
              />
            </div>
            <div className="grid grid-rows-1 grid-cols-1 gap-4">
              <div className="mb-3 ">
                <Autocomplete
                  id="unit-add-project-autocomplete"
                  options={projects}
                  getOptionLabel={(option) => option?.title ?? ""}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  value={selectedProject}
                  onChange={(_, newValue) => {
                    setSelectedProject(newValue);
                    setValue("isSignature", newValue?.isSignature);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("SELECT_PROJECT")}
                      placeholder={t("SELECT_PROJECT")}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgb(249 250 251)",
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="unitType"
                  inputLabel={
                    <>
                      {t("O_TYPE")} <span className="text-red-500">*</span>
                    </>
                  }
                  type="select"
                  options={propertyCategoryTypes}
                  defaultValue={t("O_TYPE")}
                  register={register("unitType", {
                    required: "Please enter unit type.",
                    validate: (value) => {
                      return value.trim() ? true : "White spaces not allowed.";
                    },
                  })}
                  errors={errors}
                />
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="unitNumber"
                    inputLabel={
                      <>
                        {t("O_NUMBER")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="text"
                    register={register("unitNumber", {
                      required: "Please enter unit number.",
                      validate: (value) => {
                        return value.trim()
                          ? true
                          : "White spaces not allowed.";
                      },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="unitTypeNumber"
                  inputLabel={t("O_UNIT_TYPE_NUMBER")}
                  type="select"
                  options={[
                    { key: "Select", value: "" },
                    ...unitTypeNumbers,
                  ]}
                  register={register("unitTypeNumber")}
                  errors={errors}
                />
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="slug"
                    inputLabel={
                      <>
                        {t("O_SLUG")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="text"
                    register={register("slug", {
                      required: "Please enter unit slug.",
                      validate: (value) => {
                        return value.trim()
                          ? true
                          : "White spaces not allowed.";
                      },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="slugAr"
                    inputLabel={
                      <>
                        {t("O_SLUG") + t("O_ARABIC")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="text"
                    register={register("slugAr", {
                      required: "Please enter unit slug.",
                      validate: (value) => {
                        return value.trim()
                          ? true
                          : "White spaces not allowed.";
                      },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3 ">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="floor"
                  inputLabel={<>{t("O_FLOOR")}</>}
                  type="select"
                  options={florOption}
                  defaultValue={t("SELECT_FLOOR")}
                  register={register("floor")}
                  errors={errors}
                />
              </div>
              <div className="mb-3 ">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="blockName"
                  inputLabel={<>{t("O_BLOCK_NAME")}</>}
                  type="select"
                  options={blockOption}
                  defaultValue={t("SELECT_BLOCK_NAME")}
                  register={register("blockName")}
                  errors={errors}
                />
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4"></div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="cost"
                    inputLabel={<>{t("O_PRICE")}</>}
                    type="number"
                    // register={register("cost")}
                    errors={errors}
                    step="any"
                    value={taxPrice.cost}
                    onChange={(e) =>
                      setTaxPrice({ ...taxPrice, cost: e.target.value })
                    }
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="propertyTaxPercentage"
                    inputLabel={t("PROPERTY_TAX_PER")}
                    type="number"
                    step="any"
                    value={taxPrice.propertyTaxPercentage}
                    onChange={(e) =>
                      handleInputChange("propertyTaxPercentage", e.target.value)
                    }
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    disabled
                    wrapperClassName="relative z-0 w-full group"
                    name="propertyTax"
                    inputLabel={t("PROPERTY_TAX")}
                    type="number"
                    step="any"
                    value={taxPrice.propertyTax}
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="commissionPercentage"
                    inputLabel={t("COMMISSION_PER")}
                    type="number"
                    errors={errors}
                    value={taxPrice.commissionPercentage}
                    step="any"
                    onChange={(e) =>
                      handleInputChange("commissionPercentage", e.target.value)
                    }
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    disabled
                    wrapperClassName="relative z-0 w-full group"
                    name="commission"
                    inputLabel={t("COMMISSION")}
                    type="number"
                    errors={errors}
                    value={taxPrice.commission}
                    step="any"
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="commissionTaxPercentage"
                    inputLabel={t("COMMISSION_TAX_PER")}
                    type="number"
                    errors={errors}
                    value={taxPrice.commissionTaxPercentage}
                    step="any"
                    onChange={(e) =>
                      handleInputChange(
                        "commissionTaxPercentage",
                        e.target.value,
                      )
                    }
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    disabled
                    wrapperClassName="relative z-0 w-full group"
                    name="commissionTax"
                    inputLabel={t("COMMISSION_TAX")}
                    type="number"
                    errors={errors}
                    value={taxPrice.commissionTax}
                    step="any"
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="bedroom"
                  inputLabel={<>{t("O_BEDROOM")}</>}
                  type="select"
                  options={bedroomOption}
                  defaultValue={t("SELECT_BEDROOM")}
                  register={register("bedroom")}
                  errors={errors}
                />
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3 ">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="bathroom"
                  inputLabel={<>{t("O_BATHROOM")}</>}
                  type="select"
                  options={bathroomOption}
                  defaultValue={t("SELECT_BATHROOM")}
                  register={register("bathroom")}
                  errors={errors}
                />
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="totalArea"
                    inputLabel={<>{t("O_TOTAL_AREA")}</>}
                    type="number"
                    register={register("totalArea")}
                    errors={errors}
                    step="any"
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="netArea"
                    inputLabel={<>{t("O_NET_AREA")}</>}
                    type="number"
                    register={register("netArea")}
                    errors={errors}
                    step="any"
                  />
                </label>
              </div>{" "}
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="builtArea"
                    inputLabel={<>{t("O_BUILT_AREA")}</>}
                    type="number"
                    register={register("builtArea")}
                    errors={errors}
                    step="any"
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="unitAreaOwnership"
                    inputLabel={<>{t("O_UNIT_AREA_OWNER")}</>}
                    type="number"
                    register={register("unitAreaOwnership")}
                    errors={errors}
                    step="any"
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="percentUnitAreaOwner"
                    inputLabel={<>{t("O_UNIT_PER_OWNER")}</>}
                    type="number"
                    register={register("percentUnitAreaOwner")}
                    errors={errors}
                    step="any"
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-1 gap-4">
              <h4 className="text-lg font-semibold py-3">{t("O_PLAN")}</h4>
              <div className="photo_list flex flex-wrap gap-5">
                <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  onClick={() => planRef?.current?.click()}
                >
                  <div className="text-center">
                    <img
                      src="../images/uploadimg.png"
                      className="m-auto"
                      alt=""
                    />
                    <strong className="my-2 block text-xl">
                      {t("ADD_PHOTO")}
                    </strong>
                    <strong className="my-2 block ">
                      {t("(Max size 2 MB)")}
                    </strong>
                    <span className="block text-sm font-medium">
                      {t("MIN_IMAGE_TEXT")}
                    </span>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="plan"
                      ref={planRef}
                      onChange={(e) => handlePhotosChange(e, "plan")}
                      className="hidden"
                      multiple
                    />
                  </div>
                </div>

                {/* <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  // onClick={() => {photosRef?.current?.click()}}
                >
                  <input
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    name="plan"
                    ref={photosRef}
                    onChange={(e) => handlePhotosChange(e, "plan")}
                    // className='hidden'
                    multiple
                  />
                  <div className="text-center mt-4"></div>
                </div> */}
                {plan?.map((item, index) => (
                  <div
                    key={index}
                    //onDragStart={(e) => dragStart(e, index)}
                    //onDragEnter={(e) => dragEnter(e, index)}
                    //onDragEnd={drop}
                    //draggable
                    style={{ cursor: "move" }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === "object"
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, "plan")}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
              </div>

              {/* <h4 className="text-lg font-semibold py-3">
                {t('O_RATINA_PLAN')}
              </h4>
              <div className="photo_list flex flex-wrap gap-5">
                <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  onClick={() => ratinaPlanRef?.current?.click()}
                >
                  <div className="text-center">
                    <img
                      src="../images/uploadimg.png"
                      className="m-auto"
                      alt=""
                    />
                    <strong className="my-2 block text-xl">
                      {t('ADD_PHOTO')}
                    </strong>
                    <strong className="my-2 block ">
                      {t('(Max size 2 MB)')}
                    </strong>
                    <span className="block text-sm font-medium">
                      {t('MIN_IMAGE_TEXT')}
                    </span>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="ratinaPlan"
                      ref={ratinaPlanRef}
                      onChange={(e) => handlePhotosChange(e, 'ratinaPlan')}
                      className="hidden"
                      multiple
                    />
                  </div>
                </div>

                {ratinaPlan?.map((item, index) => (
                  <div
                    key={index}
                    style={{ cursor: 'move' }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === 'object'
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, 'ratinaPlan')}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
              </div> */}
            </div>

            <div className="grid grid-rows-1 grid-cols-1 gap-4">
              <h4 className="text-lg font-semibold py-3">{t("O_IMAGE")}</h4>
              <div className="photo_list flex flex-wrap gap-5">
                <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  onClick={() => imageRef?.current?.click()}
                >
                  <div className="text-center">
                    <img
                      src="../images/uploadimg.png"
                      className="m-auto"
                      alt=""
                    />
                    <strong className="my-2 block text-xl">
                      {t("ADD_PHOTO")}
                    </strong>
                    <strong className="my-2 block ">
                      {t("(Max size 2 MB)")}
                    </strong>
                    <span className="block text-sm font-medium">
                      {t("MIN_IMAGE_TEXT")}
                    </span>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="image"
                      ref={imageRef}
                      onChange={(e) => handlePhotosChange(e, "image")}
                      className="hidden"
                      multiple
                    />
                  </div>
                </div>

                {image?.map((item, index) => (
                  <div
                    key={index}
                    style={{ cursor: "move" }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === "object"
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, "image")}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
              </div>

              {/* <h4 className="text-lg font-semibold py-3">{t('O_VR')}</h4>
              <div className="photo_list flex flex-wrap gap-5">
                <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  onClick={() => vrRef?.current?.click()}
                >
                  <div className="text-center">
                    <img
                      src="../images/uploadimg.png"
                      className="m-auto"
                      alt=""
                    />
                    <strong className="my-2 block text-xl">
                      {t('ADD_PHOTO')}
                    </strong>
                    <strong className="my-2 block ">
                      {t('(Max size 2 MB)')}
                    </strong>
                    <span className="block text-sm font-medium">
                      {t('MIN_IMAGE_TEXT')}
                    </span>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="vrImage"
                      ref={vrRef}
                      onChange={(e) => handlePhotosChange(e, 'vrImage')}
                      className="hidden"
                      multiple
                    />
                  </div>
                </div>
                {vrImage?.map((item, index) => (
                  <div
                    key={index}
                    style={{ cursor: 'move' }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === 'object'
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, 'vrImage')}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
              </div> */}
            </div>

            <div className="grid grid-rows-1 grid-cols-1 gap-4">
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="youtubeUrl"
                    inputLabel={<>{t("O_YOUTUBE_URL")}</>}
                    type="text"
                    register={register("youtubeUrl")}
                    errors={errors}
                  />
                </label>
              </div>

              {/* <h4 className="text-lg font-semibold py-3">
                {t('O_RATINA_IMAGE')}
              </h4>
              <div className="photo_list flex flex-wrap gap-5">
                <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  onClick={() => ratinaImageRef?.current?.click()}
                >
                  <div className="text-center">
                    <img
                      src="../images/uploadimg.png"
                      className="m-auto"
                      alt=""
                    />
                    <strong className="my-2 block text-xl">
                      {t('ADD_PHOTO')}
                    </strong>
                    <strong className="my-2 block ">
                      {t('(Max size 2 MB)')}
                    </strong>
                    <span className="block text-sm font-medium">
                      {t('MIN_IMAGE_TEXT')}
                    </span>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="ratinaImage"
                      ref={ratinaImageRef}
                      onChange={(e) => handlePhotosChange(e, 'ratinaImage')}
                      className="hidden"
                      multiple
                    />
                  </div>
                </div>
                {ratinaImage?.map((item, index) => (
                  <div
                    key={index}
                    style={{ cursor: 'move' }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === 'object'
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, 'ratinaImage')}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
              </div> */}
            </div>

            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="parkingSpace"
                    inputLabel={<>{t("O_PARKING_SPACE")}</>}
                    type="number"
                    register={register("parkingSpace")}
                    errors={errors}
                    step="any"
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="utilitySpace"
                    inputLabel={<>{t("O_PVT_UTILITY_SPACE")}</>}
                    type="text"
                    register={register("utilitySpace")}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3 ">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="appBrochure"
                    inputLabel="App Brochure"
                    type="number"
                    register={register("appBrochure")}
                    errors={errors}
                    step="any"
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="url360"
                    inputLabel="360 URL"
                    type="text"
                    register={register("url360")}
                    errors={errors}
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-3 gap-4">
              <div className="mb-3">
                <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  {t("O_SELECT_PAYMENT")}
                </p>
                <OMultiSelect
                  wrapperClassName="relative z-0 mb-6 w-full group"
                  name="paymentOptions "
                  placeholder={
                    <>
                      {t("O_SELECT_PAYMENT")}
                      <span className="text-red-500">*</span>
                    </>
                  }
                  options={paymentOptionsArray}
                  defaultValue={t("O_SELECT_PAYMENT")}
                  onChange={setPaymentOption}
                  value={paymentOptions}
                />
              </div>
            </div>

            <h4 className="text-lg font-semibold py-3">{t("O_COMPONENTS")}</h4>
            {paymentPercent?.length > 0 &&
              paymentPercent?.map((item, index) => {
                return (
                  <div
                    className="flex gap-4 xl:gap-12  w-auto inline-block px-3 mb-2 rounded-sm"
                    key={index}
                  >
                    <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/2">
                      <label className="block">
                        <span className="block text-sm font-medium mb-2">
                          {t("O_COMPONENT")}
                        </span>
                        <input
                          type="text"
                          name="component"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          // placeholder={t('O_TITLE')}
                          value={item?.component}
                          onChange={(e) => {
                            setPaymentPercent(
                              paymentPercent?.map((res, ind) => {
                                if (ind === index) {
                                  return {
                                    ...res,
                                    component: e.target.value,
                                  };
                                } else {
                                  return res;
                                }
                              }),
                            );
                          }}
                        />
                      </label>
                    </div>
                    <div className="py-3 mb-1 flex-0 w-1/2 xl:w-1/2">
                      <label className="block">
                        <span className="block text-sm font-medium mb-2">
                          {t("O_COMPONENT_AR")}
                        </span>
                        <input
                          type="text"
                          name="component"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          // placeholder={t('O_TITLE')}
                          value={item?.componentAr}
                          onChange={(e) => {
                            setPaymentPercent(
                              paymentPercent?.map((res, ind) => {
                                if (ind === index) {
                                  return {
                                    ...res,
                                    componentAr: e.target.value,
                                  };
                                } else {
                                  return res;
                                }
                              }),
                            );
                          }}
                        />
                      </label>
                    </div>
                    <div className="flex items-center">
                      <button
                        type="button"
                        className="ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]"
                        onClick={() =>
                          deleteMore("percentage", index, item?.component)
                        }
                      >
                        <span className=" text-[#222]  text-lg " title="Close">
                          ×
                        </span>
                      </button>
                    </div>
                  </div>
                );
              })}
            <button
              className="text-blue-400"
              type="button"
              onClick={addMorePaymentPercentage}
            >
              {t("ADD_MORE")}
            </button>

            {/* <div className="grid grid-rows-1 grid-cols-1 gap-4">
              <h4 className="text-lg font-semibold py-3">{t('O_INTERIOR')}</h4>
              <div className="photo_list flex flex-wrap gap-5">
                <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  onClick={() => interiorRef?.current?.click()}
                >
                  <div className="text-center">
                    <img
                      src="../images/uploadimg.png"
                      className="m-auto"
                      alt=""
                    />
                    <strong className="my-2 block text-xl">
                      {t('ADD_PHOTO')}
                    </strong>
                    <strong className="my-2 block ">
                      {t('(Max size 2 MB)')}
                    </strong>
                    <span className="block text-sm font-medium">
                      {t('MIN_IMAGE_TEXT')}
                    </span>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="interior"
                      ref={interiorRef}
                      onChange={(e) => handlePhotosChange(e, 'interior')}
                      className="hidden"
                      multiple
                    />
                  </div>
                </div>

                {interior?.map((item, index) => (
                  <div
                    key={index}
                    style={{ cursor: 'move' }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === 'object'
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, 'interior')}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
              </div>

              <h4 className="text-lg font-semibold py-3">
                {t('O_RATINA_INTERIOR')}
              </h4>
              <div className="photo_list flex flex-wrap gap-5">
                <div
                  className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                  onClick={() => ratinainteriorRef?.current?.click()}
                >
                  <div className="text-center">
                    <img
                      src="../images/uploadimg.png"
                      className="m-auto"
                      alt=""
                    />
                    <strong className="my-2 block text-xl">
                      {t('ADD_PHOTO')}
                    </strong>
                    <strong className="my-2 block ">
                      {t('(Max size 2 MB)')}
                    </strong>
                    <span className="block text-sm font-medium">
                      {t('MIN_IMAGE_TEXT')}
                    </span>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="ratinaInterior"
                      ref={ratinainteriorRef}
                      onChange={(e) => handlePhotosChange(e, 'ratinaInterior')}
                      className="hidden"
                      multiple
                    />
                  </div>
                </div>
                {ratinaInterior?.map((item, index) => (
                  <div
                    key={index}
                    style={{ cursor: 'move' }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === 'object'
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, 'ratinaInterior')}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
              </div>
            </div> */}

            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t("META_DESCRIPTION")}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <textarea
                  type="text"
                  name="message"
                  id="metaDescription"
                  autocomplete="off"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=""
                  {...register("metaDescription")}
                />
              </div>
            </div>
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t("META_DESCRIPTION") + t("O_ARABIC")}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <textarea
                  type="text"
                  name="message"
                  id="metaDescriptionAr"
                  autocomplete="off"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=""
                  {...register("metaDescriptionAr")}
                />
              </div>
            </div>

            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t("META_KEYWORDS")}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <textarea
                  type="text"
                  name="message"
                  id="metaKeywords"
                  autocomplete="off"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=""
                  {...register("metaKeywords")}
                />
              </div>
            </div>
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t("META_KEYWORDS") + t("O_ARABIC")}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <textarea
                  type="text"
                  name="message"
                  id="metaKeywordsAr"
                  autocomplete="off"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=""
                  {...register("metaKeywordsAr")}
                />
              </div>
            </div>
            {/* Deven Chhaparwal updated code for field view and view AR. */}
            <div className="grid grid-rows-1 grid-cols-2 gap-4">
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="view"
                    inputLabel={<>{t("VIEW")}</>}
                    type="text"
                    register={register("view")}
                    errors={errors}
                  />
                </label>
              </div>
              <div className="mb-3">
                <label className="block">
                  <OInputField
                    wrapperClassName="relative z-0   w-full group"
                    name="viewAr"
                    inputLabel={<>{t("VIEW") + t("O_ARABIC")}</>}
                    type="text"
                    register={register("viewAr")}
                    errors={errors}
                  />
                </label>
              </div>
            </div>

            <div className="grid grid-rows-1 grid-cols-3 gap-4">
              <div className="mb-3 ">
                <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  {t("IS_MAIN")}
                </p>
                <label
                  className="inline-flex relative items-center cursor-pointer"
                  title={t("IS_MAIN")}
                >
                  <input
                    type="checkbox"
                    // value="yes"
                    className="sr-only peer"
                    checked={isMain}
                    id="isMain"
                    name="isMain"
                    onChange={(e) => setIsMain(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
              <div className="mb-3 ">
                <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  {t("IS_OFFER")}
                </p>
                <label
                  className="inline-flex relative items-center cursor-pointer"
                  title={t("IS_OFFER")}
                >
                  <input
                    type="checkbox"
                    // value="yes"
                    className="sr-only peer"
                    checked={isSpecialOffer}
                    id="isSpecialOffer"
                    name="isSpecialOffer"
                    onChange={(e) => setIsSpecialOffer(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
              <div className="mb-3 ">
                <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Is Mortgage Available
                </p>
                <label
                  className="inline-flex relative items-center cursor-pointer"
                  title="Is Mortgage Available"
                  // title={`${
                  //   item?.status === 'yes' ? 'Yes' : 'No'
                  // }`}
                >
                  <input
                    type="checkbox"
                    // value="yes"
                    className="sr-only peer"
                    checked={isMortgageAvailable}
                    id="isMortgageAvailable"
                    name="isMortgageAvailable"
                    onChange={(e) => setIsMortgageAvailable(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
              <div className="mb-3 ">
                <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Show In Website
                </p>
                <label
                  className="inline-flex relative items-center cursor-pointer"
                  title="Show In Website"
                  // title={`${
                  //   item?.status === 'yes' ? 'Yes' : 'No'
                  // }`}
                >
                  <input
                    type="checkbox"
                    // value="yes"
                    className="sr-only peer"
                    checked={showInWebsite}
                    id="showInWebsite"
                    name="showInWebsite"
                    onChange={(e) => setShowInWebsite(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
              <div className="mb-3 ">
                <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Show In Agent App
                </p>
                <label
                  className="inline-flex relative items-center cursor-pointer"
                  title="Show In Agent App"
                  // title={`${
                  //   item?.status === 'yes' ? 'Yes' : 'No'
                  // }`}
                >
                  <input
                    type="checkbox"
                    // value="yes"
                    className="sr-only peer"
                    checked={showInAgentApp}
                    id="showInAgentApp"
                    name="showInAgentApp"
                    onChange={(e) => setShowInAgentApp(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
              <div className="mb-3 ">
                <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Show In Customer App
                </p>
                <label
                  className="inline-flex relative items-center cursor-pointer"
                  title="Show In Customer App"
                  // title={`${
                  //   item?.status === 'yes' ? 'Yes' : 'No'
                  // }`}
                >
                  <input
                    type="checkbox"
                    // value="yes"
                    className="sr-only peer"
                    checked={showInCustomerApp}
                    id="showInCustomerApp"
                    name="showInCustomerApp"
                    onChange={(e) => setShowInCustomerApp(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
              <div className="mb-3 ">
                <OSelect
                  wrapperClassName="relative z-0  w-full group"
                  name="status"
                  inputLabel={<>{t("O_STATUS")}</>}
                  type="select"
                  options={statusOption}
                  defaultValue={t("SELECT_STATUS")}
                  register={register("status")}
                  errors={errors}
                />
              </div>
            </div>
            <div className="border-t mt-10 py-10 text-center">
              <button className="bg-lime-500 hover:bg-[#8FC150] cursor-pointer text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150">
                {t("SAVE_&_CONTINUE")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddUnit;
